export default __webpack_public_path__ + "static/media/pastel-mobile.80275dd7.jpg";